var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFeatureEnabled !== null)?_c('IFrameContainer',{attrs:{"dashboard":_vm.isFeatureEnabled ? 88: 6,"project":_vm.isFeatureEnabled ? 'foodics':'skylineDynamics'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }